import { useEffect } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

export const SheetNavigation = ({
  currentIndex,
  length,
  setIndex,
}: {
  currentIndex: number | null;
  length: number;
  setIndex: (index: number | null) => void;
}) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (
        event.key === "ArrowLeft" &&
        currentIndex !== null &&
        currentIndex > 0
      ) {
        setIndex(currentIndex - 1);
      } else if (
        event.key === "ArrowRight" &&
        currentIndex !== null &&
        currentIndex < length - 1
      ) {
        setIndex(currentIndex + 1);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [currentIndex, length, setIndex]);

  return (
    <div className="flex items-center gap-1">
      <Button
        className="rounded-full"
        disabled={currentIndex === 0}
        onClick={() => {
          if (currentIndex === null) return;
          setIndex(currentIndex - 1);
        }}
        size="icon"
        variant="secondary"
      >
        <ChevronLeftIcon className="h-4 w-4 text-slate-700" />
      </Button>
      <Button
        className="rounded-full"
        disabled={currentIndex === length - 1}
        onClick={() => {
          if (currentIndex === null) return;
          setIndex(currentIndex + 1);
        }}
        size="icon"
        variant="secondary"
      >
        <ChevronRightIcon className="h-4 w-4 text-slate-700" />
      </Button>
    </div>
  );
};
